export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./trans-bets.vue?vue&type=template&id=88246e3a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/trans-bets.vue?vue&type=template&id=88246e3a&scoped=true
// module id = MZfE
// module chunks = 0